module.exports = __webpack_public_path__ + "static/img/contact_bg1.3390620.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contact/contact_bg1.png
// module id = 6JAG
// module chunks = 1